import { Pipe, PipeTransform } from '@angular/core';

//
// 1:1 port of the decodeEntities filter in gmr-app.js.
//
@Pipe({ name: 'decodeEntities', pure: true })
export class DecodeEntitiesPipe implements PipeTransform
{
  transform(input: string | null | undefined): string | null | undefined
  {
    if (!input) return input;
    const txt = document.createElement('textarea');
    txt.innerHTML = input;
    return txt.value;
  }
}
